module.exports = "/images/PI.png?2c416a0bc4bbb933253efe2a00a3bace";